import { TypeNotificationWithoutUnresolvableLinksResponse } from 'contentful-types'
import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import Notification from './Notification'

const ContentfulNotification = withContentful<TypeNotificationWithoutUnresolvableLinksResponse['fields']>(
  Notification,
  {
    content: (props) => <BlockRenderer block={props.fields?.content} fieldPath={'richText'} />,
    style: (props) => props.fields.style.toLowerCase(),
    dismissible: (props) => props.fields.dismissible,
    system: (props) => props.fields.system,
    spacer: mapSpacer,
    textPosition: (props) => props.fields?.textPosition?.toLowerCase(),
  }
)

export default ContentfulNotification
